import { IAuction } from "../Interfaces/Database/Auction";

export const bidsViewable = (auction: IAuction): boolean => {
  return auction.preBiddingOpen && auction.preBiddingViewingOption && auction.preBiddingViewingOption === 'onBid'
    || auction.state > 1;
};